import config from 'constants/config'

export default function isSupportPageEnabled(): boolean {
  return config.SUPPORT_ENABLED && !!config.supportUrl
}
